import { render } from "./rqzjManager.vue?vue&type=template&id=e1291b44"
import script from "./rqzjManager.vue?vue&type=script&lang=js"
export * from "./rqzjManager.vue?vue&type=script&lang=js"

import "./rqzjManager.vue?vue&type=style&index=0&id=e1291b44&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__